export default __webpack_public_path__ + "static/media/governence.16dc81da.svg";